import { WidgetComponentProps } from '../wilsonChat.types'
import { ConfirmEstimateDetailsWidget } from './ConfirmEstimateDetailsWidget'
import { ConfirmShipmentDetailsWidget } from './ConfirmShipmentDetailsWidget'
import { DataChartWidget } from './DataChartWidget'
import { SendConciergeWidget } from './SendConciergeWidget'
import { SendEmailWidget } from './SendEmailWidget'
import { ShipmentCreatedWidget } from './ShipmentCreatedWidget'

export const WIDGET_KEY = {
    confirmShipmentDetails: 'ConfirmShipmentDetails',
    confirmEstimateDetails: 'ConfirmEstimateDetails',
    shipmentCreated: 'ShipmentCreated',
    sendEmail: 'SendEmail',
    sendConciergeMessage: 'SendConciergeMessage',
    dataChart: 'DataChart',
} as const

export const FORM_WIDGETS: string[] = [
    WIDGET_KEY.confirmShipmentDetails,
    WIDGET_KEY.confirmEstimateDetails,
    WIDGET_KEY.sendEmail,
    WIDGET_KEY.sendConciergeMessage,
]

export const WIDE_WIDGETS: string[] = [
    WIDGET_KEY.dataChart,
    // All form widgets are wide
    ...FORM_WIDGETS,
]

export const WIDGET_KEY_TO_WIDGET_COMPONENT: {
    [widgetKey in (typeof WIDGET_KEY)[keyof typeof WIDGET_KEY]]: React.FC<
        WidgetComponentProps<string, any>
    >
} = {
    [WIDGET_KEY.confirmShipmentDetails]: ConfirmShipmentDetailsWidget,
    [WIDGET_KEY.shipmentCreated]: ShipmentCreatedWidget,
    [WIDGET_KEY.confirmEstimateDetails]: ConfirmEstimateDetailsWidget,
    [WIDGET_KEY.sendEmail]: SendEmailWidget,
    [WIDGET_KEY.sendConciergeMessage]: SendConciergeWidget,
    [WIDGET_KEY.dataChart]: DataChartWidget,
}
